import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations, LANG_ORDER } from "@/data/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("en");

  useEffect(() => {
    const stored = localStorage.getItem("bob_lang");
    if (LANG_ORDER.includes(stored)) setLang(stored);
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
    document.documentElement.setAttribute("lang", lang);
    localStorage.setItem("bob_lang", lang);
  }, [lang]);

  const cycle = useCallback(() => {
    setLang((prev) => {
      const idx = LANG_ORDER.indexOf(prev);
      return LANG_ORDER[(idx + 1) % LANG_ORDER.length];
    });
  }, []);

  const t = translations[lang] || translations.en;
  const isRTL = lang === "ar";

  return (
    <LanguageContext.Provider value={{ lang, setLang, cycle, toggle: cycle, t, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
